require("!!/mnt/STORAGE/apice.promemoriagroup.com/wp/wp-content/themes/apice-theme/webpack/node_modules/script-loader/addScript.js")(require("!!/mnt/STORAGE/apice.promemoriagroup.com/wp/wp-content/themes/apice-theme/webpack/node_modules/raw-loader/index.js!/mnt/STORAGE/apice.promemoriagroup.com/wp/wp-content/themes/apice-theme/webpack/node_modules/photoswipe/dist/photoswipe.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/photoswipe/dist/photoswipe.js
// module id = 20
// module chunks = 1